import { render, staticRenderFns } from "./Flex.vue?vue&type=template&id=cf9f3194&scoped=true&lang=pug"
import script from "./Flex.vue?vue&type=script&lang=js"
export * from "./Flex.vue?vue&type=script&lang=js"
import style0 from "./Flex.vue?vue&type=style&index=0&id=cf9f3194&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f3194",
  null
  
)

export default component.exports